export enum PROJECT_NAME {
  VISA_GCC = 'visaGcc',
  VISA_SSA = 'visaSsa',
  VISA_FOREX = 'visaForex',
  VISA_CAMBODIA = 'visaCambodia',
  VISA_HAJJ = 'visaHajj',
}
